// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"879c69ab","140":"f845a965","172":"1eb7f7cf","315":"4772a387","354":"791fe1bf","573":"bb07983f","599":"aab47f0c","670":"7ba9b228","779":"e615b3dd","862":"cebee56e","893":"6d18ba59","922":"33bde95d"}[chunkId] + ".chunk.js";
};